import React, { useState, useEffect } from "react";
import "./BackToTop.css";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      const nextVisible = window.scrollY > 300;
      setVisible((currentVisible) => (
        currentVisible === nextVisible ? currentVisible : nextVisible
      ));
    };

    toggleVisible();
    window.addEventListener("scroll", toggleVisible, { passive: true });

    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    visible && (
      <button className="back-to-top" onClick={scrollToTop}>
        ↑
      </button>
    )
  );
}

export default BackToTop;
